// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"13":"5e522e18","53":"abb9ea00","707":"34b2775a"}[chunkId] + ".chunk.js";
};